/**
 * API Configuration
 *
 * Automatically detects environment:
 * - Development: Uses localhost:3001
 * - Production: Uses relative path (same domain)
 * - Override: Use VITE_API_BASE_URL environment variable
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.MODE === 'development' ? 'http://localhost:3001' : '');

/**
 * Helper to build API URLs
 * @param {string} path - API path (e.g., '/api/runs')
 * @returns {string} Full URL
 */
export function apiUrl(path) {
  return `${API_BASE_URL}${path}`;
}

export default API_BASE_URL;
